import { render, staticRenderFns } from "./riskAssessmentTemplates.vue?vue&type=template&id=5096d384&scoped=true"
import script from "./riskAssessmentTemplates.vue?vue&type=script&lang=js"
export * from "./riskAssessmentTemplates.vue?vue&type=script&lang=js"
import style0 from "./riskAssessmentTemplates.vue?vue&type=style&index=0&id=5096d384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5096d384",
  null
  
)

export default component.exports